/* eslint-disable no-unused-vars */
export enum AllergenSelectionStatus {
    ManuallyAdded = "ManuallyAdded",
    DetectedByAI = "DetectedByAI",
    DetectedByAIDisabledManually = "DetectedByAIDisabledManually"
}
/* eslint-enable no-unused-vars */

export interface SelectedAllergen {
    id: number;
    code?: string;
    name?: string;
    aliasNames: number[];
    aliasName?: string | number;
    status: AllergenSelectionStatus | number;
    aiRecipeAggregateId?: number | null;
}

export type SavedAllergen = SelectedAllergen | string | number;
